// extracted by mini-css-extract-plugin
export default {"item":"styles_item__z4hD4","field":"styles_field__ma3F3"};